import { mountLegalPage } from './mount-legal';

mountLegalPage('cookies');
